const { readField, loadSubItems } = require('../fields/index')
const common = require('./common')

const component = (subField, loc = 'en=AU') => ({
  ...common(subField, null, subField.fields.cmsTitle, loc),
  entities: loadSubItems(readField(subField.fields.entities, loc)),
  rowProperties: readField(subField.fields.rowProperties, loc),
  rowTitle: readField(subField.fields.rowTitle, loc),
  cmsTitle: readField(subField.fields.rowTitle, loc),
})

module.exports = component
module.exports.tryLoad = (subField, loc = 'en-AU') => {
  if (subField.sys.contentType.sys.id === 'sectionRow') {
    return component(subField, loc)
  }
  return null
}

module.exports.load = (data, loc = 'en-AU') => {
  const locations = data.entries.filter(
    e => e.sys.contentType.sys.id === 'sectionRow'
  )

  const processedLocations = locations.map(l => component(l, loc))
  const result = {}
  processedLocations.forEach(l => {
    result[l.id] = l
    result[l.title] = l
  })
  return result
}
